i<template>
  <div :class="classes">
    <!-- <button @click="onClick()"  class="custom-btn btn-16"> -->
    <!-- <span style="color: black" class="icon_refresh"></span> -->
    <!-- <div v-if="!VisibleIcon" class="loader5 " ></div> -->

    <!-- <div class="loader5" :class="VisibleIcon?'animate':''" ></div> -->
    <!-- </button> -->
    <button class="refreshButton" @click="onClick()">
      <i class="icon_refresh"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "Button",
  data() {
    return {
      // VisibleIcon:false,
    };
  },
  props: {
    VisibleIcon: {
      type: Boolean,
      default: false,
    },

    classes: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.VisibleIcon = true;
      setTimeout(() => (this.VisibleIcon = false), 2000);
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped>
button {
  margin: 5px;
}
.custom-btn {
  width: 80px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  /* box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
   7px 7px 20px 0px rgba(0,0,0,.1),
   4px 4px 5px 0px rgba(0,0,0,.1); */
  outline: none;
}

/* 16 */
.btn-16 {
  border: none;
  color: #000;
}
.btn-16:after {
  position: absolute;
  content: "";
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  direction: rtl;
  z-index: -1;
  box-shadow: -7px -7px 20px 0px #fff9, -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002, 4px 4px 5px 0px #0001;
  transition: all 0.3s ease;
}
.btn-16:hover {
  color: #000;
}
.btn-16:hover:after {
  left: auto;
  right: 0;
  width: 100%;
}
.btn-16:active {
  top: 2px;
}

body {
  background: #000 !important;
  color: #fff;
}

.loader5 {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #4183d7;
  border-top: 10px solid #f5ab35;
}
.animate {
  -webkit-animation: loader5 20s ease-in-out infinite alternate;
  animation: loader5 1.2s ease-in-out infinite alternate;
  transition-duration: 20s !important;
}
@keyframes loader5 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(720deg);
  }
}
@-webkit-keyframes loader5 {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(720deg);
  }
}

.refreshButton {
  outline: unset;
  border: none;
  background: unset;
  font-size: 21px;
}
</style>
